import { render, staticRenderFns } from "./abroad-address.vue?vue&type=template&id=20a82944&scoped=true&"
import script from "./abroad-address.vue?vue&type=script&lang=js&"
export * from "./abroad-address.vue?vue&type=script&lang=js&"
import style0 from "./abroad-address.vue?vue&type=style&index=0&id=20a82944&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a82944",
  null
  
)

export default component.exports